import React, { useEffect, useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import {
  Avatar,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Modal,
  Stack,
  Typography
} from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BoosterPng from '../../assets/Booster.png';
import DefaultAvatar from '../../assets/defaultPostImg.jpg';
import { LetsGoBtn } from '../../components/Buttons';
import { StyledLabel } from '../../components/StyledComponents';

import { setIsOpenAccountPromoteModal, setIsOpenBoostersModal } from '../../redux/mainReducer';
import './CancelModal.css';
import ApiService from '../../helpers/apiHelper';
import { base } from '../../redux/thunk';
import { useSnackbar } from 'notistack';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: { xs: 390, sm: 710, md: 800, lg: 800, xl: 800 },

  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px 20px 30px 20px', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function AccountPromoteModal({ isOpenModal, userData, boosters, getUserDataThunk }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const api = new ApiService('auth/promote-user');
  // eslint-disable-next-line
  const [valuePrice, setValuePrice] = useState(2);
  const [dayCount, setDayCount] = useState(1);

  const [interesting, setInteresting] = useState(true);
  const [search, setSearch] = useState(false);
  const [boostersError, setBoostersError] = useState(false);

  const calc = () => {
    return dayCount * valuePrice;
  };
  const getPlace = () => {
    if (interesting && !search) {
      return ['INTERESTED_USERS_PLACE'];
    } else if (search && !interesting) {
      return ['USER_SEARCH_PLACE'];
    } else if (interesting && search) {
      return ['USER_SEARCH_PLACE', 'INTERESTED_USERS_PLACE'];
    }
  };

  const submit = () => {
    api
      .postDataQuery({ timePromoteType: dayCount, placePromoteType: [...getPlace()] })
      .then((res) => {
        enqueueSnackbar(`Просування акаунту активовано`, { variant: 'success' });
        dispatch(setIsOpenAccountPromoteModal(false));
        getUserDataThunk();
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка', { variant: 'error' });
      });
  };
  useEffect(() => {
    if (boosters < dayCount * valuePrice) {
      setBoostersError(true);
    } else {
      setBoostersError(false);
    }
  }, [boosters, dayCount, valuePrice]);

  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(setIsOpenAccountPromoteModal(false));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_cancel_modal"
      >
        <Box sx={style} className="bonfair_cancel_modal-box">
          <CloseIcon
            className="bonfair_cancel_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenAccountPromoteModal(false));
            }}
          />

          <Grid container spacing={0}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="cancelModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                {'Просувати профіль'}
              </StyledLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                  padding: '8px',
                  borderRadius: '8px',
                  mb: '16px',
                  mt: '24px'
                }}
              >
                <Avatar
                  onClick={() => {
                    navigate(`/ua/user-page/${userData?.id}?type=posts`);
                  }}
                  src={
                    userData?.encodedMediaDTO
                      ? `data:${userData?.encodedMediaDTO.contentType};base64, ${userData?.encodedMediaDTO.encodedContent}`
                      : DefaultAvatar
                  }
                  sx={{
                    width: { xs: '60px', sm: '80px' },
                    height: { xs: '60px', sm: '80px' },
                    border: '2px solid #E2F2FF',
                    cursor: 'pointer',
                    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                  }}
                />
                <Stack sx={{ width: '100%', marginLeft: '10px' }}>
                  <Typography
                    variant="subtitle"
                    sx={{
                      fontFamily: 'FixelText-Medium !important',
                      fontWeight: 500,
                      fontSize: { xs: '14px', sm: '16px' },
                      textAlign: 'left',
                      cursor: 'pointer',
                      color: '#7c7c7c'
                    }}
                    onClick={() => {
                      navigate(`/ua/user-page/${userData.id}?type=posts`);
                    }}
                  >
                    {`@${userData?.nickname}`}
                  </Typography>
                  {userData?.name && userData?.surname && (
                    <Typography
                      variant="subtitle"
                      sx={{
                        fontFamily: 'FixelText-Medium !important',
                        fontWeight: 500,
                        fontSize: { xs: '18px', sm: '20px' },
                        textAlign: 'left',
                        cursor: 'pointer',
                        wordBreak: 'break-word',
                        textWrap: 'break-word'
                      }}
                      onClick={() => {
                        navigate(`/ua/user-page/${userData.id}?type=posts`);
                      }}
                      // src={
                      //   user?.encodedMediaDTO
                      //     ? `data:${user?.encodedMediaDTO.contentType};base64, ${user?.encodedMediaDTO.encodedContent}`
                      //     : DefaultAvatar
                      // }
                    >
                      {`${userData?.name} ${userData?.surname}`}
                    </Typography>
                  )}
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{ pb: '16px', borderBottom: '3px solid #F5F4F4', mb: { xs: '16px', sm: '24px' } }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    gap: '10px',
                    alignItems: 'center',
                    // border: '1px solid #C8C8C8',

                    borderRadius: '5px',
                    width: '100%',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    textAlign: 'left',
                    color: '#7C7C7C'
                  }}
                >
                  {`Баланс бустерів: `}
                  <Typography
                    variant="p"
                    sx={{
                      margin: '0px 0px',
                      wordBreak: 'break-word',
                      fontFamily: 'FixelText-Medium !important',
                      fontWeight: 500,
                      fontSize: '16px',
                      textAlign: 'left',
                      alignItems: 'center',
                      display: 'flex',
                      color: boostersError ? 'red' : 'black'
                    }}
                  >
                    {boosters}
                    <img
                      width={22}
                      height={18}
                      src={BoosterPng}
                      alt="booster"
                      style={{ marginRight: '10px', marginLeft: '10px', marginBottom: '5px' }}
                    />
                  </Typography>
                  <LetsGoBtn
                    colorScheme="white"
                    width="140px"
                    margin="0px 0px 0px auto"
                    text="Поповнити"
                    onClick={() => {
                      dispatch(setIsOpenBoostersModal(true));
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/*<Stack sx={{ width: '100%' }}>*/}
              <Typography
                variant="p"
                sx={{
                  margin: '0px 0px 10px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  textAlign: 'left',
                  color: '#7C7C7C'
                }}
              >
                Оберіть місце просування:
              </Typography>

              <FormGroup
                onChange={(event, value) => {
                  if (event?.target?.name === 'interesting') {
                    setInteresting(!interesting);
                    if (event.target?.checked) {
                      setValuePrice(valuePrice + 2);
                    } else {
                      setValuePrice(valuePrice - 2);
                    }
                  } else if (event?.target?.name === 'search') {
                    setSearch(!search);
                    if (event.target?.checked) {
                      setValuePrice(valuePrice + 2);
                    } else {
                      setValuePrice(valuePrice - 2);
                    }
                  }
                }}
              >
                <FormControlLabel
                  sx={{ mr: '0px' }}
                  control={
                    <Checkbox
                      size="large"
                      disableRipple
                      checked={interesting}
                      sx={{ p: '0px 5px 0px 10px !important' }}
                    />
                  }
                  name="interesting"
                  label={
                    <Typography
                      sx={{
                        fontSize: { xs: '16px', sm: '18px', md: '20px' },
                        fontFamily: 'FixelText-Regular !important'
                      }}
                    >
                      {'Блок “Користувачі, які вас можуть зацікавити”'}
                    </Typography>
                  }
                />
                <FormControlLabel
                  sx={{ mr: '0px' }}
                  control={
                    <Checkbox
                      size="large"
                      disableRipple
                      checked={search}
                      sx={{ p: '0px 5px 0px 10px !important' }}
                    />
                  }
                  name="search"
                  label={
                    <Typography
                      sx={{
                        fontSize: { xs: '16px', sm: '18px', md: '20px' },
                        fontFamily: 'FixelText-Regular !important'
                      }}
                    >
                      {'Сторінка пошуку людей'}
                    </Typography>
                  }
                />
              </FormGroup>
              {/*</Stack>*/}
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                pb: '16px',
                borderBottom: '3px solid #F5F4F4',
                mb: { xs: '16px', sm: '24px' }
              }}
            >
              {/*<Stack sx={{ width: '100%', ml: 1 }}>*/}
              {/*<Typography*/}
              {/*  variant="p"*/}
              {/*  sx={{*/}
              {/*    margin: '0px 0px 10px',*/}
              {/*    wordBreak: 'break-word',*/}
              {/*    fontFamily: 'FixelText-Regular !important',*/}
              {/*    fontSize: { xs: '16px', sm: '18px', md: '20px' },*/}
              {/*    color: '#7c7c7c',*/}
              {/*    textAlign: 'left'*/}
              {/*  }}*/}
              {/*>*/}
              {/*  Оберіть тривалість просування:*/}
              {/*</Typography>*/}
              <Box sx={{ display: 'flex', height: 20, mb: '24px' }}>
                <Typography
                  variant="p"
                  sx={{
                    margin: '10px 0px 10px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    color: '#7c7c7c',
                    textAlign: 'left'
                  }}
                >
                  Ціна просування:
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    margin: '10px 0px 10px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    color: '#7c7c7c',
                    textAlign: 'left',
                    ml: 'auto'
                  }}
                >
                  {valuePrice}
                  <img
                    width={20}
                    height={16}
                    src={BoosterPng}
                    alt="booster"
                    style={{ marginLeft: '5px', marginRight: '5px' }}
                  />{' '}
                  /день
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', height: 20, mb: '16px' }}>
                <Typography
                  variant="p"
                  sx={{
                    margin: '10px 20px 0px 0px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    color: '#7c7c7c',
                    textAlign: 'left'
                  }}
                >
                  Кількість днів:
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '0px',
                    ml: 'auto',
                    mt: '10px'
                  }}
                >
                  <Typography
                    sx={{
                      cursor: 'pointer',
                      p: 1,
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: dayCount === 1 ? '#F5F4F4' : '#E2F2FF',
                      borderRadius: '50px',
                      fontSize: '20px'
                    }}
                    onClick={() => dayCount > 1 && setDayCount(dayCount - 1)}
                  >
                    -
                  </Typography>
                  {/*<TextField*/}
                  {/*  variant={'standard'}*/}
                  {/*  sx={{ maxWidth: '30px', margin: '0px 10px' }}*/}
                  {/*  inputProps={{ style: { textAlign: 'center' } }}*/}
                  {/*  value={dayCount}*/}
                  {/*  onChange={(event) => {*/}
                  {/*    if (*/}
                  {/*      Number.isInteger(+event.target.value) &&*/}
                  {/*      +event.target.value <= 999 &&*/}
                  {/*      +event.target.value !== 0*/}
                  {/*    ) {*/}
                  {/*      setDayCount(+event.target.value);*/}
                  {/*    }*/}
                  {/*  }}*/}
                  {/*/>*/}
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium !important',
                      fontWeight: '500',
                      fontSize: { xs: '16px', sm: '18px', md: '20px' },
                      color: '#1B1B1B',
                      m: '0px 5px'
                    }}
                  >
                    {dayCount}
                  </Typography>
                  <Typography
                    sx={{
                      cursor: 'pointer',
                      p: 1,
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: '#E2F2FF',
                      borderRadius: '50px',
                      fontSize: '20px'
                    }}
                    onClick={() => dayCount < 999 && setDayCount(dayCount + 1)}
                  >
                    +
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{
                margin: '0px 0px 10px'
              }}
            >
              <Typography
                variant="p"
                sx={{
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '14px', sm: '16px' },
                  textAlign: 'left',
                  color: '#7C7C7C'
                }}
              >
                Зверніть увагу! Якщо тривалість просування перевищує залишок днів підписки, а
                підписку не буде продовжено, просування припиниться після її завершення. Бустери не
                підлягають поверненню.
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                {' '}
                <Typography
                  sx={{
                    margin: '0px ',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    textAlign: 'left',
                    color: '#7c7c7c',
                    width: '100%'
                  }}
                >
                  До сплати:
                </Typography>
                <Typography
                  sx={{
                    color: boostersError ? 'red' : 'black',
                    marginLeft: 'auto',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {calc()}
                  <img
                    width={20}
                    height={16}
                    src={BoosterPng}
                    alt="booster"
                    style={{ marginLeft: '10px' }}
                  />
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                margin: '20px auto 0px',
                maxWidth: '540px',
                position: 'relative'
              }}
            >
              <LetsGoBtn
                colorScheme="blue"
                lineHeight="26px"
                disabled={boosters < dayCount * valuePrice || (!interesting && !search)}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  submit();
                }}
                width={180}
                margin={'0 auto'}
                style={{ textTransform: 'inherit' }}
                text="Просувати"
              />
              <Typography
                sx={{
                  color: boostersError ? 'red' : 'black',
                  position: 'absolute',
                  bottom: '-20px',
                  display: boostersError ? 'flex' : 'none',
                  alignItems: 'center',
                  fontSize: '14px'
                }}
              >
                {boosters < dayCount * valuePrice ? 'Недостатьно бустерів' : ''}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    boosters: state.global.boosters
  };
};
export default connect(mapStateToProps, { getUserDataThunk: base?.getUserDataThunk })(
  AccountPromoteModal
);
